/**
 * Session State Manager - Simple AJAX-based session state tracking
 * Calls session state update once per page load and sets up event listeners
 */

/**
 * Gets the session state update URL from hidden input field
 * @returns {string} The URL for session state updates
 */
function getUpdateUrl() {
    var urlField = $('#sessionStateUpdateUrl');
    return urlField.length > 0 ? urlField.data('url') : '';
}

/**
 * Makes AJAX call to update session state
 */
function updateSessionState() {
    var updateUrl = getUpdateUrl();
    
    if (!updateUrl) {
        console.warn('Session state update URL not found in hidden input field');
        return;
    }
    
    $.ajax({
        url: updateUrl,
        type: 'GET',
        dataType: 'json'
    })
        .done(function (response) {
            if (response.success) {
                $(document).trigger('sessionStateUpdated');
            }
        })
        .fail(function (xhr, status, error) {
            console.error('Session state update failed:', status, error);
        });
}

/**
 * Sets up event listeners for cart and login state changes
 */
function setupEventListeners() {
    // Listen for AJAX completions that might change cart/login state
    $(document).ajaxComplete(function (event, xhr, settings) {
        if (settings.url && (
            settings.url.indexOf('Cart-') !== -1 ||
            settings.url.indexOf('AddProduct') !== -1 ||
            settings.url.indexOf('RemoveProduct') !== -1 ||
            settings.url.indexOf('UpdateQuantity') !== -1 ||
            settings.url.indexOf('Login') !== -1 ||
            settings.url.indexOf('Logout') !== -1
        )) {
            setTimeout(function () {
                updateSessionState();
            }, 100);
        }
    });

    $(document).on('cartUpdate loginStateChange', function () {
        updateSessionState();
    });
}

module.exports = function () {
    updateSessionState();
    setupEventListeners();
};
